import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ConnectorsUIState {
  searchQuery: string;
  statusFilter: string;
  syncingConnectorId: string | null;
}

const initialState: ConnectorsUIState = {
  searchQuery: '',
  statusFilter: '',
  syncingConnectorId: null,
};

const connectorsSlice = createSlice({
  name: 'connectorsUI',
  initialState,
  reducers: {
    setConnectorsSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    setConnectorsStatusFilter(state, action: PayloadAction<string>) {
      state.statusFilter = action.payload;
    },
    setSyncingConnector(state, action: PayloadAction<string | null>) {
      state.syncingConnectorId = action.payload;
    },
  },
});

export const { setConnectorsSearchQuery, setConnectorsStatusFilter, setSyncingConnector } =
  connectorsSlice.actions;
export default connectorsSlice.reducer;
